var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled)?_c('div',{staticClass:"circle_number disabled"},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_c('div',{staticClass:"circle_number primary primary--text"},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }